import React from 'react';
import { MessageCircle } from 'lucide-react';
import { clinicInfo } from '../data/mock';

const WhatsAppButton = () => {
  return (
    <a
      href={`https://wa.me/${clinicInfo.phone.replace(/[^0-9]/g, '')}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        width: '60px',
        height: '60px',
        background: 'var(--interactive-base)',
        color: 'var(--bg-primary)',
        borderRadius: '0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.2s cubic-bezier(.645,.045,.355,1)',
        zIndex: 1000,
        textDecoration: 'none'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'var(--interactive-hover)';
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'var(--interactive-base)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
      }}
    >
      <MessageCircle size={28} />
    </a>
  );
};

export default WhatsAppButton;
